import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqsData } from '../data/content';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';
import Button from './ui/Button';

const FAQItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b border-warm-stone/30 last:border-0">
      <button 
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
        onClick={onClick}
      >
        <h3 className="text-base md:text-lg font-medium text-deep-charcoal pr-8 group-hover:text-olive-grove transition-colors">
          {faq.q}
        </h3>
        <span className="text-estate-bronze flex-shrink-0">
          {isOpen ? <SafeIcon icon={FiMinus} className="w-4 h-4" /> : <SafeIcon icon={FiPlus} className="w-4 h-4" />}
        </span>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-deep-charcoal/70 font-light leading-relaxed text-sm md:text-base">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-vintage-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-charcoal mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-px bg-estate-bronze mx-auto"></div>
        </div>

        <div className="bg-aged-ivory p-6 md:p-10 rounded-2xl border border-warm-stone/30 shadow-sm">
          {faqsData.map((faq, index) => (
            <React.Fragment key={index}>
              <FAQItem 
                faq={faq} 
                isOpen={index === openIndex} 
                onClick={() => setOpenIndex(index === openIndex ? -1 : index)} 
              />
              {index === 4 && (
                <motion.div 
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  className="my-8 p-8 bg-vintage-white border border-estate-bronze/20 rounded-xl text-center shadow-editorial"
                >
                  <p className="text-deep-charcoal/80 font-light mb-6 leading-relaxed">
                    Still comparing venues? A private tour is the easiest way to understand the setting, guest flow, and starting estimate.
                  </p>
                  <Button href="https://tour.paduaweddings.com" variant="primary" className="text-sm px-6 py-3">
                    Schedule Your Private Tour
                  </Button>
                </motion.div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;